import type { IconSvgObject } from './types';

const TeaPodIcon: IconSvgObject = [
  ["path", { d: "M10 10V6.5C10 4.01472 12.0147 2 14.5 2C16.9853 2 19 4.01472 19 6.5V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 9.5V7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 22C7.89543 22 7 21.1046 7 20V17L2 11L3.5 9L8 11.5C8 11.5 10 9.5 14.5 9.5C17.7848 9.5 20.2704 11.0985 21.3732 11.9618C21.7909 12.2888 22 12.798 22 13.3284V20C22 21.1046 21.1046 22 20 22H9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TeaPodIcon;
